import { Box, } from "@chakra-ui/react";
import { useNavigate, } from "react-router-dom";
import { useCallback, useLayoutEffect, useState, } from "react";

import { RoutesMap, } from "../../routes.tsx";
import { QrViewDefault, } from "./QrViewDefault.tsx";
import { useQRStore, } from "../../store/qrStore.ts";
import { QrViewMaxMiniApp, } from "./QrViewMaxMiniApp.tsx";
import { useModeratorStore, } from "../../store/moderatorStore.ts";

export function QrPage() {
  const navigate = useNavigate();

  const { isModerator, setModeratorQR, } = useModeratorStore(state => state,);
  const setQRPayload = useQRStore(state => state.setQRPayload,);

  const [isMaxMiniApp, setIsMaxMiniApp,] = useState<boolean>(false,);

  useLayoutEffect(() => {
    if (window.WebApp?.platform === "android" || window.WebApp?.platform === "ios") {
      setIsMaxMiniApp(true,);
    }
  }, [],);

  const onSuccess = useCallback((code: string,) => {
    if (!code) {
      return;
    }

    if (isModerator) {
      setModeratorQR(code,);
      navigate(RoutesMap.index,);
      return;
    }

    setQRPayload(code,);
    navigate(RoutesMap.qr.payment,);
  }, [navigate, setQRPayload,],);

  const onError = useCallback((error: unknown,) => {
    console.error("Error", error,);
  }, [],);

  return (
    <Box h="100vh" mx="-1rem" position="relative">
      {isMaxMiniApp
        ? <QrViewMaxMiniApp onSuccess={onSuccess} onError={onError} />
        : <QrViewDefault onSuccess={onSuccess} onError={onError} />}
    </Box>
  );
}
